<template>
    <button type="button"
        class="group flex w-full items-center justify-between space-x-8 border-b
            border-solid border-gray-100 py-md pr-md">
        <div class="flex flex-1 items-center justify-between space-x-2">
            <v-placeholder v-if="status === 'pending'"
                class="w-48 rounded text-base before:via-gray-200">
                ....
            </v-placeholder>

            <template v-else>
                <span class="font-bold">
                    {{ $t('reviews.reviews-count', totalRatingCount) }}
                </span>

                <div class="flex items-center space-x-px">
                    <v-icon v-for="i in 5"
                        :key="i"
                        :icon="getIcon(i, rating)" />
                </div>
            </template>
        </div>

        <v-icon icon="chevron-right" />
    </button>
</template>

<script setup lang="ts">
const properties = defineProps<{
    skus: string[]
}>();

const {
    getRating,
    getIcon,
} = useReviews();

const { rating, status, totalRatingCount } = getRating(properties.skus);
</script>
